module.exports = __webpack_public_path__ + "img/53bc0b3.jpg";